// ── Master Permissions Config ──────────────────────────────────────────
// Add new sections here → automatically appears in permissions panel
// Format: { key, label, actions, subsections }
// actions: array of 'view' | 'add' | 'edit' | 'delete'
// subsections: array of { key, label }

export const PERMISSION_SECTIONS = [

  // ── CORE SECTIONS ────────────────────────────────────────────────────
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: '🏠',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'products',
    label: 'Products',
    icon: '📦',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: [
      { key: 'simple', label: 'Simple Products' },
      { key: 'variants', label: 'Variant Products' },
    ]
  },
  {
    key: 'ordersCash',
    label: 'Orders — Cash',
    icon: '💵',
    actions: ['view', 'edit', 'delete'],
    subsections: [
      { key: 'pending', label: 'Pending' },
      { key: 'confirmed', label: 'Confirmed' },
      { key: 'dispatched', label: 'Dispatched' },
      { key: 'delivered', label: 'Delivered' },
      { key: 'cancelled', label: 'Cancelled' },
    ]
  },
  {
    key: 'ordersInstallment',
    label: 'Orders — Installment',
    icon: '📋',
    actions: ['view', 'edit', 'delete'],
    subsections: [
      { key: 'pending', label: 'Pending' },
      { key: 'processing', label: 'Processing' },
      { key: 'atManager', label: 'At City Manager' },
      { key: 'tryAgain', label: 'Try Again' },
      { key: 'scheduled', label: 'Scheduled' },
      { key: 'rejectedByAgent', label: 'Rejected by Agent' },
      { key: 'rejectedByBranch', label: 'Rejected by Branch' },
      { key: 'rejectedByManager', label: 'Rejected by Manager' },
      { key: 'cancelled', label: 'Cancelled' },
    ]
  },
  {
    key: 'categories',
    label: 'Categories & Brands',
    icon: '🏷️',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'employees',
    label: 'Employee Management',
    icon: '👥',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'hr',
    label: 'HR Management',
    icon: '🗂️',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: [
      { key: 'departments', label: 'Departments' },
      { key: 'positions', label: 'Positions' },
      { key: 'records', label: 'Employee Records' },
    ]
  },
  {
    key: 'accounting',
    label: 'Accounting',
    icon: '📊',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'mobilistanInstant',
    label: 'Mobilistan Instant',
    icon: '⚡',
    actions: ['view', 'add', 'edit', 'delete'],
    // approveApplications: the only way, besides Admin / Super Admin, to approve or reject an
    // Instant application or a shop offer (owner, 5 Oct 2026). The server reads this same key:
    // functions/lib/employeeLookup.js hasApproveTick. Counts only with `view` on.
    subsections: [
      { key: 'approveApplications', label: 'Approve / reject applications' },
    ]
  },
  {
    key: 'stock',
    label: 'Stock Management',
    icon: '🏭',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'branches',
    label: 'Branches',
    icon: '🏢',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'settings',
    label: 'Website Settings',
    icon: '⚙️',
    actions: ['view', 'edit'],
    subsections: []
  },
  {
    key: 'reports',
    label: 'Reports & Analytics',
    icon: '📈',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'liveMap',
    label: 'Live Map',
    icon: '🗺️',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'recoveryReports',
    label: 'Recovery Reports',
    icon: '💰',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'inquiryReports',
    label: 'Inquiry Reports',
    icon: '🔍',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'gpsSettings',
    label: 'GPS Settings',
    icon: '📍',
    actions: ['view', 'edit'],
    subsections: []
  },
  {
    key: 'agentReports',
    label: 'Agent Reports',
    icon: '📊',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'stockSearch',
    label: 'Stock Search',
    icon: '🔎',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'inquiryDashboard',
    label: 'Inquiry Officer Dashboard',
    icon: '📞',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'recoveryDashboard',
    label: 'Recovery Officer Dashboard',
    icon: '💼',
    actions: ['view'],
    subsections: []
  },

  // ── HR SECTIONS ──────────────────────────────────────────────────────
  {
    key: 'leaves',
    label: 'Leave Management',
    icon: '🏖️',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: [
      { key: 'pending', label: 'Pending Requests' },
      { key: 'approved', label: 'Approved' },
      { key: 'rejected', label: 'Rejected' },
    ]
  },
  {
    key: 'warnings',
    label: 'Warnings & Disciplinary',
    icon: '⚠️',
    actions: ['view', 'add', 'delete'],
    subsections: [
      { key: 'verbal', label: 'Verbal Warning' },
      { key: 'written', label: 'Written Warning' },
      { key: 'final', label: 'Final Warning' },
      { key: 'suspension', label: 'Suspension' },
    ]
  },
  {
    key: 'transfers',
    label: 'Employee Transfer',
    icon: '🔄',
    actions: ['view', 'add'],
    subsections: []
  },
  {
    key: 'holidays',
    label: 'Holiday Calendar',
    icon: '📅',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'payroll',
    label: 'Salary & Payroll',
    icon: '💳',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },

  // ── CUSTOMER SECTIONS ─────────────────────────────────────────────────
  {
    key: 'complaints',
    label: 'Customer Complaints',
    icon: '📢',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: [
      { key: 'open', label: 'Open' },
      { key: 'inProgress', label: 'In Progress' },
      { key: 'resolved', label: 'Resolved' },
      { key: 'closed', label: 'Closed' },
    ]
  },
  {
    key: 'blacklist',
    label: 'Customer Blacklist',
    icon: '🚫',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'customerUpgrade',
    label: 'Customer Upgrade',
    icon: '⬆️',
    actions: ['view', 'add'],
    subsections: []
  },
  {
    key: 'planChangeRequests',
    label: 'Plan Change Requests',
    icon: '🔃',
    actions: ['view', 'add', 'edit'],
    subsections: [
      { key: 'pending', label: 'Pending' },
      { key: 'approved', label: 'Approved' },
      { key: 'rejected', label: 'Rejected' },
    ]
  },
  {
    key: 'guarantorChangeRequests',
    label: 'Guarantor Change Requests',
    icon: '👤',
    actions: ['view', 'add', 'edit'],
    subsections: [
      { key: 'pending', label: 'Pending' },
      { key: 'approved', label: 'Approved' },
      { key: 'rejected', label: 'Rejected' },
    ]
  },
  {
    key: 'earlyPayment',
    label: 'Early / Full Payment',
    icon: '✅',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },
  {
    key: 'customerHistory',
    label: 'Customer Address / Number History',
    icon: '📝',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'satisfactionRatings',
    label: 'Satisfaction Ratings',
    icon: '⭐',
    actions: ['view'],
    subsections: []
  },

  // ── ORDER SECTIONS ────────────────────────────────────────────────────
  {
    key: 'orderReinstatement',
    label: 'Order Reinstatement',
    icon: '↩️',
    actions: ['view', 'add'],
    subsections: []
  },
  {
    key: 'orderPriority',
    label: 'Order Priority Flag',
    icon: '🚩',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },
  {
    key: 'orderAuditTrail',
    label: 'Order Audit Trail',
    icon: '🔎',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'cancellationCategories',
    label: 'Cancellation Categories',
    icon: '❌',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'referralTracking',
    label: 'Referral Source Tracking',
    icon: '🔗',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },

  // ── RECOVERY SECTIONS ─────────────────────────────────────────────────
  {
    key: 'paymentReminders',
    label: 'Payment Reminder Schedule',
    icon: '⏰',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },
  {
    key: 'overdueEscalation',
    label: 'Overdue Escalation',
    icon: '📈',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'productReturns',
    label: 'Product Returns',
    icon: '🔙',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },
  {
    key: 'guarantorVerification',
    label: 'Guarantor Verification',
    icon: '✔️',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },

  // ── REPORTING SECTIONS ────────────────────────────────────────────────
  {
    key: 'cashFlowReport',
    label: 'Cash Flow Report',
    icon: '💹',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'branchPerformance',
    label: 'Branch Performance',
    icon: '🏆',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'targetAchievement',
    label: 'Target vs Achievement',
    icon: '🎯',
    actions: ['view', 'add', 'edit'],
    subsections: []
  },
  {
    key: 'dailySummary',
    label: 'Daily Summary Report',
    icon: '📋',
    actions: ['view', 'edit'],
    subsections: []
  },
  {
    key: 'attendanceReport',
    label: 'Attendance Report',
    icon: '🕐',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'installmentCalculator',
    label: 'Installment Calculator',
    icon: '🧮',
    actions: ['view'],
    subsections: []
  },

  // ── COMMUNICATION SECTIONS ────────────────────────────────────────────
  {
    key: 'notifications',
    label: 'Notifications',
    icon: '🔔',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'announcements',
    label: 'Announcements',
    icon: '📣',
    actions: ['view', 'add', 'edit', 'delete'],
    subsections: []
  },
  {
    key: 'whatsappTemplates',
    label: 'WhatsApp Templates',
    icon: '💬',
    actions: ['view', 'edit'],
    subsections: []
  },
  {
    key: 'whatsappBroadcast',
    label: 'WhatsApp Group Broadcast',
    icon: '📡',
    actions: ['view', 'add'],
    subsections: []
  },

  // ── SECURITY SECTIONS ─────────────────────────────────────────────────
  {
    key: 'sessionManagement',
    label: 'Session Management',
    icon: '🔐',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'loginMonitoring',
    label: 'Login Attempt Monitoring',
    icon: '🛡️',
    actions: ['view', 'edit'],
    subsections: []
  },
  {
    key: 'permissionAuditLog',
    label: 'Permission Audit Log',
    icon: '📜',
    actions: ['view'],
    subsections: []
  },
  {
    key: 'activityLog',
    label: 'Activity Log',
    icon: '📰',
    actions: ['view'],
    subsections: []
  },
];

// ── The approver tick is set by its own checkbox only ─────────────────
// mobilistanInstant.subsections.approveApplications decides who may approve or reject
// applications (functions/lib/employeeLookup.js). "Select all", a section's "all subsections"
// and permission templates (which staff can write) never set it: isSoloSubsection marks it, and
// withApproverTickFrom keeps an employee's own value when a template is applied.
const SOLO_SUBSECTIONS = { mobilistanInstant: ['approveApplications'] };
export const isSoloSubsection = (sectionKey, subKey) =>
  (SOLO_SUBSECTIONS[sectionKey] || []).includes(subKey);

/** `perms` with the approver tick taken from `own` (the employee's current permissions), not from `perms`. */
export const withApproverTickFrom = (perms, own) => {
  const p = perms && typeof perms === 'object' ? perms : {};
  const ownTick = own?.mobilistanInstant?.subsections?.approveApplications === true;
  const mi = p.mobilistanInstant;
  if (!mi && !ownTick) return p;
  const section = mi && typeof mi === 'object' ? mi : (mi === true ? { view: true } : {});
  return {
    ...p,
    mobilistanInstant: { ...section, subsections: { ...(section.subsections || {}), approveApplications: ownTick } },
  };
};

/** `perms` with the approver tick off — what a permission template may carry. */
export const withoutApproverTick = (perms) => withApproverTickFrom(perms, null);

// ── Helper: get section by key ────────────────────────────────────────
export const getSectionByKey = (key) =>
  PERMISSION_SECTIONS.find(s => s.key === key);

// ── Helper: check if employee has permission ──────────────────────────
// Defensive against null/undefined: default-parameter `= {}` only applies
// to `undefined`, not `null`. Callers (App.js → AppLayout → AppSidebar)
// pass `permissions={null}` for non-admin roles, so this guard prevents
// `null[sectionKey]` TypeError on render.
export const hasPermission = (permissions, sectionKey, action = 'view') => {
  if (permissions === null || permissions === undefined) return false;
  const section = permissions[sectionKey];
  if (!section) return false;
  if (typeof section === 'boolean') return section; // backward compat with flat schema
  return !!section[action];
};

// ── Helper: check subsection permission ──────────────────────────────
export const hasSubPermission = (permissions, sectionKey, subsectionKey) => {
  if (permissions === null || permissions === undefined) return false;
  const section = permissions[sectionKey];
  if (!section || !section.view) return false;
  if (!section.subsections) return false;
  return !!section.subsections[subsectionKey];
};

// ── Helper: build empty permissions object ────────────────────────────
export const buildEmptyPermissions = () => {
  const perms = {};
  PERMISSION_SECTIONS.forEach(section => {
    perms[section.key] = {};
    section.actions.forEach(action => {
      perms[section.key][action] = false;
    });
    if (section.subsections.length > 0) {
      perms[section.key].subsections = {};
      section.subsections.forEach(sub => {
        perms[section.key].subsections[sub.key] = false;
      });
    }
  });
  return perms;
};

// ── Helper: merge position base + employee override ───────────────────
export const mergePermissions = (basePermissions = {}, overridePermissions = {}) => {
  const merged = { ...buildEmptyPermissions() };
  PERMISSION_SECTIONS.forEach(section => {
    const base = basePermissions[section.key] || {};
    const override = overridePermissions[section.key] || {};
    merged[section.key] = {};
    section.actions.forEach(action => {
      merged[section.key][action] = override[action] ?? base[action] ?? false;
    });
    if (section.subsections.length > 0) {
      merged[section.key].subsections = {};
      section.subsections.forEach(sub => {
        const baseVal = base.subsections?.[sub.key] ?? false;
        const overrideVal = override.subsections?.[sub.key];
        merged[section.key].subsections[sub.key] = overrideVal ?? baseVal;
      });
    }
  });
  return merged;
};

// ── Legacy key aliases ────────────────────────────────────────────────
// Old flat-schema records used different key names for 3 sections. These
// aliases let normalizePermissions translate them on read.
export const PERMISSION_KEY_ALIASES = {
  orderCash:        'ordersCash',
  orderInstallment: 'ordersInstallment',
  catalog:          'categories',
};

// ── Helper: normalize legacy/partial permissions to canonical shape ───
// Accepts: flat-boolean records, nested records, partial records, or null.
// Returns: a fully-populated nested permissions object with all
// PERMISSION_SECTIONS keys present. Legacy `{ products: true }` expands
// to `{ products: { view: true, add: false, edit: false, delete: false } }`.
export const normalizePermissions = (raw) => {
  if (!raw || typeof raw !== 'object') return buildEmptyPermissions();
  const out = buildEmptyPermissions();
  Object.entries(raw).forEach(([key, value]) => {
    const newKey = PERMISSION_KEY_ALIASES[key] || key;
    if (!out[newKey]) return; // skip keys not in PERMISSION_SECTIONS
    if (typeof value === 'boolean') {
      if (value) out[newKey].view = true;
    } else if (value && typeof value === 'object') {
      const section = PERMISSION_SECTIONS.find(s => s.key === newKey);
      if (!section) return;
      section.actions.forEach(a => {
        if (value[a] !== undefined) out[newKey][a] = !!value[a];
      });
      if (section.subsections.length > 0 && value.subsections) {
        section.subsections.forEach(sub => {
          if (value.subsections[sub.key] !== undefined) {
            out[newKey].subsections[sub.key] = !!value.subsections[sub.key];
          }
        });
      }
    }
  });
  return out;
};
